import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bedStatusAPI } from '../apis';
import { updateBedStatusViewVal } from '../redux/actions';
import { CUBICLE_VIEW2 } from '../redux/constant';

const useBsViewSetting = () => {
  const loginInfo = useSelector((state) => state.loginInfo);
  const dispatch = useDispatch();
  const { defaultViewType } = useSelector((state) => state.bedStatusView);

  const getViewSettingAPI = useCallback(async () => {
    try {
      if (loginInfo.wardId) {
        const { result } = await bedStatusAPI.getViewSettingDetail();
        dispatch(
          updateBedStatusViewVal({
            currentViewType: result.viewType,
            defaultViewType: result.viewType,
            isCubicleV2: result.viewType === CUBICLE_VIEW2,
          })
        );
      }
    } catch (error) {}
  }, [loginInfo.wardId, dispatch]);

  useEffect(() => {
    getViewSettingAPI();
  }, [getViewSettingAPI]);

  const updateViewSetting = async (viewType) => {
    try {
      await bedStatusAPI.updateViewSetting({ viewType });
      dispatch(
        updateBedStatusViewVal({
          defaultViewType: viewType,
          currentViewType: viewType,
          isCubicleV2: viewType === CUBICLE_VIEW2,
        })
      );
    } catch (error) {}
  };

  return { defaultViewType, updateViewSetting };
};

export default useBsViewSetting;
